import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ZorroTableComponent } from '../../common/custom-table/zorro-table.component';

@Component({
  selector: 'app-user-confirmation-modal',
  standalone: true,
  imports: [CommonModule, ZorroTableComponent],
  templateUrl: './user-confirmation-modal.component.html',
  styleUrl: './user-confirmation-modal.component.scss'
})
export class UserConfirmationModalComponent implements OnInit{
  activeModal = inject(NgbActiveModal);
  private messageService = inject(MessageService);

  @Input()
  data: any = {};


  ngOnInit(): void {
    //
  }

  onButtonClick(){
    this.activeModal.close({
      value: "success",
    });
  }
}
